import React, { Component } from 'react';
import '../global';
class Password extends Component {

	constructor(props){
		super(props);
		this.password_form = getMyAccountObj().password_form;
	}
	render() {
		return (
			<div dangerouslySetInnerHTML={{ __html: this.password_form }} />
		);
	}
}

export default Password;